/* import __COLOCATED_TEMPLATE__ from './freelancer-project-analytics-totals.hbs'; */
import EmberObject, { computed } from '@ember/object';
import { A } from '@ember/array';
import Component from '@ember/component';

const CLASS_NAME = 'SH-c-freelancer-project-analytics-totals';

export default Component.extend({
  classNames: [CLASS_NAME],
  CLASS_NAME,

  /** @param {Number|null} */
  year: null,

  /** @param {Ember.A} */
  data: A([]),

  /** @type {Boolean} */
  showTotals: computed('year', function () {
    return this.get('year') !== new Date().getFullYear();
  }),

  /** @type {Ember.Object} */
  totals: computed('data.[]', function () {
    let pending = 0;
    let paid = 0;

    this.get('data').forEach((payment) => {
      const amount = payment.get('amount');

      payment.get('paidAt')
        ? paid += amount
        : pending += amount;
    });

    return EmberObject.create({ pending, paid });
  }),
});
